import { debounce } from "../../../../../../../magnolia-component-library/assets/js/utils/performance";
import { updateQueryParamsByFilters } from "../../../../../../../magnolia-component-library/assets/js/utils/queryParams";
import { handleSearchInput, searchFilterHandler, setSearchInputValue, resetSearchInputValue } from "./search";
import {
    handleCheckboxChange,
    checkboxFilterHandler,
    setCheckboxesInputValues,
    resetCheckboxesInputValues,
} from "./checkbox";
import {
    handlePaginationClick,
    paginationFilterHandler,
    setPaginationValue,
    resetPaginationValue,
} from "./pagination";
import { filterFilterCards } from "../filterCards";
import { queryParams, getFiltersValuesFromQueryParams } from "../queryParams";
import {
    toggleListItemsClass,
    convertValueToInteger,
    convertObjectStringValuesToIntegers,
    toggleNoResultsEl,
    toggleClearFiltersEls,
} from "../utils";

const filterHandlers = {
    search: {
        eventType: "input",
        filterHandler: searchFilterHandler,
        eventListener: handleSearchInput,
        setValue: setSearchInputValue,
        resetValue: resetSearchInputValue,
        debounceDelay: 300,
    },
    checkbox: {
        eventType: "change",
        filterHandler: checkboxFilterHandler,
        eventListener: handleCheckboxChange,
        setValue: setCheckboxesInputValues,
        resetValue: resetCheckboxesInputValues,
        debounceDelay: 100,
    },
    pagination: {
        eventType: "click",
        filterHandler: paginationFilterHandler,
        eventListener: handlePaginationClick,
        // "setValue": setPaginationValue,
        // "resetValue": setPaginationValue,
        debounceDelay: 100,
    },
};

export const populateFilters = (el) => {
    const filtersEls = el.querySelectorAll(".el__filter");

    if (filtersEls.length === 0) return;

    const filters = {};

    for (const filterEl of filtersEls) {
        const filterObj = {
            filterEl,
            filterListenerEl: filterEl.querySelector(".el__filter-listener"),
            value: filterEl.dataset.defaultValue || null,
            ...filterEl.dataset,
        };

        if (!filterObj.filterListenerEl || !filterObj.filterName || !filterObj.filterType) continue;

        convertObjectStringValuesToIntegers(filterObj);

        filters[filterObj.filterName] = filterObj;
    }

    setFiltersValuesFromQueryParams(filters);

    return filters;
};

const setFiltersValuesFromQueryParams = (filters) => {
    const filtersValues = getFiltersValuesFromQueryParams(queryParams, filters);

    for (const [filterName, filterValue] of Object.entries(filtersValues)) {
        if (!filters[filterName]) continue;

        const value = convertValueToInteger(filterValue);

        setFilterValue(filters[filterName], "value", value);
    }
};

export const addFiltersEventListeners = (state) => {
    if (Object.keys(state.filters).length === 0) return;

    for (const filterObj of Object.values(state.filters)) {
        if (
            !filterHandlers[filterObj.filterType] ||
            !filterHandlers[filterObj.filterType].eventType ||
            !filterHandlers[filterObj.filterType].eventListener ||
            typeof filterHandlers[filterObj.filterType].eventListener !== "function"
        )
            continue;

        filterObj.filterListenerEl.addEventListener(
            filterHandlers[filterObj.filterType].eventType,
            debounce((e) => {
                const updatedFilterValue = filterHandlers[filterObj.filterType].eventListener(filterObj, e);

                setFilterValue(filterObj, "value", updatedFilterValue);
                updateQueryParamsByFilters(queryParams, state.filters);
                filterFilterCards(state);
                filterExtensions(state);
                toggleNoResultsEl(state.noResultsEl, state.filteredExtensions.length);
                toggleClearFiltersEls(state.clearFiltersEls, state.filters);
            }, filterHandlers[filterObj.filterType].debounceDelay)
        );
    }
};

export const filterExtensions = (state) => {
    state.filteredExtensions = state.extensions;

    for (const filterObj of Object.values(state.filters)) {
        if (
            !filterObj.value ||
            !filterHandlers[filterObj.filterType].filterHandler ||
            typeof filterHandlers[filterObj.filterType].filterHandler !== "function"
        )
            continue;

        state.filteredExtensions = filterHandlers[filterObj.filterType].filterHandler(
            state.filteredExtensions,
            filterObj
        );
    }

    toggleListItemsClass(state.extensions, "remove");
    toggleListItemsClass(state.filteredExtensions, "add");
};

export const clearFilters = (state, filters, e) => {
    propagateFiltersToDOM(filters, "resetValue");

    for (const filterObj of Object.values(filters)) {
        setFilterValue(filterObj, "value", null);
    }

    updateQueryParamsByFilters(queryParams, filters);
    filterFilterCards(state);
    filterExtensions(state);
    toggleNoResultsEl(state.noResultsEl, state.filteredExtensions.length);
    toggleClearFiltersEls(state.clearFiltersEls, state.filters);
};

export const getFiltersValues = (filters, filterTypes = null) => {
    if (Object.keys(filters).length === 0) return;

    const values = [];
    let filteredFilters = filters;

    if (filterTypes) filteredFilters = getFiltersByFilterTypes(filters, filterTypes);

    for (const filterObj of Object.values(filteredFilters)) {
        if (!filterObj.value) continue;

        values.push(filterObj.value);
    }

    return values;
};

export const setFilterValue = (filterObj, propertyName, propertyValue) =>
    (filterObj[propertyName] = propertyValue ? propertyValue : null);

export const propagateFiltersToDOM = (filters, functionType) => {
    if (Object.keys(filters).length === 0) return;

    for (const filterObj of Object.values(filters)) {
        if (
            !filterObj.value ||
            !filterHandlers[filterObj.filterType][functionType] ||
            typeof filterHandlers[filterObj.filterType][functionType] !== "function"
        )
            continue;

        filterHandlers[filterObj.filterType][functionType](filterObj.filterEl, filterObj.value);
    }
};

export const getFiltersByFilterType = (filters, filterType) => {
    const filteredFilters = {};

    for (const [filterName, filterObj] of Object.entries(filters)) {
        if (filterObj.filterType !== filterType) continue;

        filteredFilters[filterName] = filterObj;
    }

    return filteredFilters;
};

export const getFiltersByFilterTypes = (filters, filterTypes) => {
    let filteredFilters = {};

    for (const filterType of filterTypes) {
        filteredFilters = { ...filteredFilters, ...getFiltersByFilterType(filters, filterType) };
    }

    return filteredFilters;
};
